export default __webpack_public_path__ + "static/media/trash.ee853db2.png";